export interface ComicChapter {
  id: string;
  title: string;
  date: string;
  pageCount: number;
}

export interface Comic {
  id: string;
  title: string;
  altTitle: string;
  author: string;
  cover: string;
  status: "连载中" | "已完结";
  rating: number;
  views: string;
  fans: string;
  categories: string[];
  tags: string[];
  description: string;
  updatedAt: string;
  latestChapter: string;
  chapters: ComicChapter[];
  featured?: boolean;
  hot?: boolean;
}

export interface ComicCategory {
  slug: string;
  name: string;
  icon: string;
  description: string;
  image: string;
}

export const categories: ComicCategory[] = [
  {
    slug: "rexue",
    name: "热血少年",
    icon: "ri-fire-fill",
    description: "燃烧斗志的热血冒险，见证少年成长的热血之路",
    image:
      "https://readdy.ai/api/search-image?query=stylized%20anime%20illustration%20of%20a%20determined%20young%20fighter%20raising%20his%20fist%20surrounded%20by%20dynamic%20orange%20flames%2C%20shonen%20manga%20art%20style%2C%20warm%20vibrant%20orange%20and%20gold%20tones%2C%20clean%20simple%20background%2C%20dramatic%20energy%20effects%2C%20high%20quality%20anime%20concept%20art%2C%20no%20text&width=800&height=600&seq=category-rexue&orientation=landscape",
  },
  {
    slug: "xiaoyuan",
    name: "校园青春",
    icon: "ri-graduation-cap-fill",
    description: "发生在教室与操场之间的青春故事与少年心事",
    image:
      "https://readdy.ai/api/search-image?query=stylized%20anime%20illustration%20of%20a%20sunny%20japanese%20high%20school%20courtyard%20with%20cherry%20blossom%20trees%20and%20students%20in%20uniform%2C%20soft%20warm%20afternoon%20light%2C%20youth%20romance%20manga%20art%20style%2C%20clean%20composition%2C%20gentle%20pink%20and%20cream%20tones%2C%20high%20quality%20anime%20concept%20art%2C%20no%20text&width=800&height=600&seq=category-xiaoyuan&orientation=landscape",
  },
  {
    slug: "gaoxiao",
    name: "搞笑日常",
    icon: "ri-emotion-laugh-fill",
    description: "笑点密集的欢乐日常，承包你一整天的好心情",
    image:
      "https://readdy.ai/api/search-image?query=stylized%20anime%20illustration%20of%20a%20group%20of%20comical%20chibi%20characters%20laughing%20and%20chasing%20each%20other%20in%20a%20colorful%20playful%20scene%2C%20comedy%20manga%20art%20style%2C%20bright%20cheerful%20yellow%20and%20orange%20palette%2C%20simple%20clean%20background%2C%20fun%20and%20energetic%20mood%2C%20high%20quality%20anime%20concept%20art%2C%20no%20text&width=800&height=600&seq=category-gaoxiao&orientation=landscape",
  },
  {
    slug: "dongzuo",
    name: "动作冒险",
    icon: "ri-sword-fill",
    description: "惊险刺激的冒险旅程，刀光剑影间的热血对决",
    image:
      "https://readdy.ai/api/search-image?query=stylized%20anime%20illustration%20of%20an%20adventurer%20holding%20a%20sword%20standing%20on%20a%20cliff%20overlooking%20a%20vast%20fantasy%20landscape%20with%20distant%20mountains%2C%20action%20adventure%20manga%20art%20style%2C%20epic%20warm%20golden%20lighting%2C%20clean%20dramatic%20composition%2C%20high%20quality%20anime%20concept%20art%2C%20no%20text&width=800&height=600&seq=category-dongzuo&orientation=landscape",
  },
  {
    slug: "qihuan",
    name: "奇幻魔法",
    icon: "ri-magic-fill",
    description: "魔法与异世界交织，属于想象力的无限可能",
    image:
      "https://readdy.ai/api/search-image?query=stylized%20anime%20illustration%20of%20a%20young%20mage%20casting%20a%20glowing%20golden%20magic%20spell%20with%20floating%20rune%20circles%20and%20sparkles%20in%20a%20mystical%20library%2C%20fantasy%20manga%20art%20style%2C%20warm%20amber%20and%20gold%20tones%2C%20clean%20simple%20background%2C%20high%20quality%20anime%20concept%20art%2C%20no%20text&width=800&height=600&seq=category-qihuan&orientation=landscape",
  },
  {
    slug: "yundong",
    name: "运动竞技",
    icon: "ri-trophy-fill",
    description: "挥洒汗水的竞技场，永不放弃的冠军之路",
    image:
      "https://readdy.ai/api/search-image?query=stylized%20anime%20illustration%20of%20a%20volleyball%20player%20leaping%20high%20to%20spike%20the%20ball%20in%20a%20bright%20indoor%20gymnasium%2C%20sports%20manga%20art%20style%2C%20dynamic%20action%20pose%2C%20warm%20energetic%20lighting%2C%20clean%20simple%20background%2C%20high%20quality%20anime%20concept%20art%2C%20no%20text&width=800&height=600&seq=category-yundong&orientation=landscape",
  },
  {
    slug: "kehuan",
    name: "科幻机甲",
    icon: "ri-robot-fill",
    description: "未来科技与钢铁巨兽，星辰大海中的机甲传说",
    image:
      "https://readdy.ai/api/search-image?query=stylized%20anime%20illustration%20of%20a%20giant%20mecha%20robot%20standing%20in%20a%20futuristic%20city%20at%20sunset%20with%20glowing%20warm%20orange%20lights%2C%20sci-fi%20mecha%20manga%20art%20style%2C%20dramatic%20scale%20and%20atmosphere%2C%20clean%20composition%2C%20high%20quality%20anime%20concept%20art%2C%20no%20text&width=800&height=600&seq=category-kehuan&orientation=landscape",
  },
  {
    slug: "zhentan",
    name: "悬疑推理",
    icon: "ri-search-eye-fill",
    description: "迷雾重重的人心谜局，与真相的极限拉扯",
    image:
      "https://readdy.ai/api/search-image?query=stylized%20anime%20illustration%20of%20a%20detective%20in%20a%20long%20coat%20standing%20in%20a%20dim%20moody%20city%20alley%20lit%20by%20warm%20street%20lamps%2C%20mystery%20thriller%20manga%20art%20style%2C%20suspenseful%20atmosphere%2C%20clean%20composition%2C%20high%20quality%20anime%20concept%20art%2C%20no%20text&width=800&height=600&seq=category-zhentan&orientation=landscape",
  },
];

export const comics: Comic[] = [
  {
    id: "jiating-jiaoshi",
    title: "家庭教师HITMAN REBORN!",
    altTitle: "家庭教师 / 泽田纲吉的日常与黑手党之路",
    author: "天野明",
    cover:
      "https://readdy.ai/api/search-image?query=anime%20manga%20cover%20art%20of%20a%20teenage%20boy%20with%20spiky%20dark%20brown%20hair%20wearing%20a%20black%20suit%20holding%20a%20small%20orange%20flame%20in%20his%20palm%2C%20dynamic%20shonen%20pose%2C%20orange%20and%20gold%20flame%20energy%20background%2C%20clean%20simple%20background%2C%20vibrant%20warm%20tones%2C%20high%20quality%20anime%20illustration%2C%20no%20text&width=480&height=640&seq=cover-family-teacher&orientation=portrait",
    status: "已完结",
    rating: 9.6,
    views: "3.2亿",
    fans: "128万",
    categories: ["rexue", "xiaoyuan", "gaoxiao"],
    tags: ["热血", "校园", "黑手党", "战斗", "搞笑"],
    description:
      "《家庭教师HITMAN REBORN!》是日本漫画家天野明创作的经典热血少年漫画，讲述了一事无成、被称作「废柴纲」的普通中学生泽田纲吉，在自称家庭教师的婴儿里包恩到来后，被卷入黑手党彭格列家族继承人之争的故事。从日常搞笑到热血战斗，纲吉在不断成长中觉醒了大空之炎，集结守护者伙伴，向着成为彭格列十代目不断前进。本作拥有大量人气角色与精彩的指环争夺战篇章，是一部融合校园、搞笑与战斗元素的经典之作。",
    updatedAt: "2026-08-13",
    latestChapter: "目标20 迈向未来",
    featured: true,
    hot: true,
    chapters: [
      { id: "ch-01", title: "目标1 新生代黑手党", date: "2026-08-13", pageCount: 10 },
      { id: "ch-02", title: "目标2 死气之炎觉醒", date: "2026-08-11", pageCount: 10 },
      { id: "ch-03", title: "目标3 家庭教师的真实身份", date: "2026-08-08", pageCount: 10 },
      { id: "ch-04", title: "目标4 彭格列指环的传说", date: "2026-08-05", pageCount: 10 },
      { id: "ch-05", title: "目标5 守护者的集结", date: "2026-08-01", pageCount: 10 },
      { id: "ch-06", title: "目标6 云雀恭弥登场", date: "2026-07-28", pageCount: 10 },
      { id: "ch-07", title: "目标7 狱寺隼人的加入", date: "2026-07-24", pageCount: 10 },
      { id: "ch-08", title: "目标8 山本武的觉悟", date: "2026-07-20", pageCount: 10 },
      { id: "ch-09", title: "目标9 幻术师之争", date: "2026-07-16", pageCount: 10 },
      { id: "ch-10", title: "目标10 与六道骸的对决", date: "2026-07-12", pageCount: 10 },
      { id: "ch-11", title: "目标11 匣兵器的秘密", date: "2026-07-08", pageCount: 10 },
      { id: "ch-12", title: "目标12 指环争夺战开启", date: "2026-07-04", pageCount: 10 },
      { id: "ch-13", title: "目标13 天空战·纲吉vs云雀", date: "2026-06-30", pageCount: 10 },
      { id: "ch-14", title: "目标14 大空之炎的觉醒", date: "2026-06-26", pageCount: 10 },
      { id: "ch-15", title: "目标15 瓦利亚来袭", date: "2026-06-22", pageCount: 10 },
      { id: "ch-16", title: "目标16 守护者之战", date: "2026-06-18", pageCount: 10 },
      { id: "ch-17", title: "目标17 最终决战", date: "2026-06-14", pageCount: 10 },
      { id: "ch-18", title: "目标18 继承者的觉悟", date: "2026-06-10", pageCount: 10 },
      { id: "ch-19", title: "目标19 新篇章·选择战", date: "2026-06-06", pageCount: 10 },
      { id: "ch-20", title: "目标20 迈向未来", date: "2026-06-02", pageCount: 10 },
    ],
  },
  {
    id: "haizei-wang",
    title: "海贼王",
    altTitle: "ONE PIECE / 草帽海贼团的伟大航路冒险",
    author: "尾田荣一郎",
    cover:
      "https://readdy.ai/api/search-image?query=anime%20manga%20cover%20art%20of%20a%20young%20pirate%20boy%20wearing%20a%20straw%20hat%20and%20red%20vest%20grinning%20confidently%2C%20dynamic%20shonen%20pose%2C%20ocean%20and%20sky%20background%20with%20warm%20sunset%20light%2C%20clean%20simple%20background%2C%20vibrant%20colors%2C%20high%20quality%20anime%20illustration%2C%20no%20text&width=480&height=640&seq=cover-onepiece&orientation=portrait",
    status: "连载中",
    rating: 9.8,
    views: "5.6亿",
    fans: "356万",
    categories: ["rexue", "dongzuo"],
    tags: ["冒险", "热血", "伙伴", "大海"],
    description:
      "《海贼王》是尾田荣一郎创作的现象级热血冒险漫画。少年路飞为了成为海贼王，与伙伴们一起扬帆出海，寻找传说中的大秘宝ONE PIECE。在伟大航路上，草帽海贼团不断遭遇强敌、结识朋友，展开一段段荡气回肠的冒险之旅。",
    updatedAt: "2026-08-12",
    latestChapter: "第1124话 新世界的黎明",
    hot: true,
    chapters: [
      { id: "ch-01", title: "第1话 我是路飞", date: "2026-08-12", pageCount: 8 },
      { id: "ch-02", title: "第2话 那个男人的名字", date: "2026-08-05", pageCount: 8 },
      { id: "ch-03", title: "第3话 海盗王与剑客", date: "2026-07-29", pageCount: 8 },
      { id: "ch-04", title: "第4话 红发香克斯", date: "2026-07-22", pageCount: 8 },
      { id: "ch-05", title: "第5话 前往伟大航路", date: "2026-07-15", pageCount: 8 },
      { id: "ch-06", title: "第6话 第一个伙伴", date: "2026-07-08", pageCount: 8 },
    ],
  },
  {
    id: "huoying-renzhe",
    title: "火影忍者",
    altTitle: "NARUTO / 鸣人的忍者修行之路",
    author: "岸本齐史",
    cover:
      "https://readdy.ai/api/search-image?query=anime%20manga%20cover%20art%20of%20a%20young%20ninja%20boy%20with%20blonde%20spiky%20hair%20wearing%20an%20orange%20jacket%20and%20blue%20headband%2C%20confident%20smile%2C%20ninja%20village%20background%20with%20warm%20sunset%20sky%2C%20clean%20simple%20background%2C%20vibrant%20colors%2C%20high%20quality%20anime%20illustration%2C%20no%20text&width=480&height=640&seq=cover-naruto&orientation=portrait",
    status: "已完结",
    rating: 9.7,
    views: "4.8亿",
    fans: "286万",
    categories: ["rexue", "dongzuo"],
    tags: ["忍者", "热血", "羁绊", "修行"],
    description:
      "《火影忍者》是岸本齐史创作的世界级热血忍者漫画。被村里人视为妖狐的少年鸣人，为了得到大家的认可，立志成为火影。在第七班的伙伴佐助、小樱以及老师卡卡西的陪伴下，鸣人不断突破自我，书写属于他的忍者传说。",
    updatedAt: "2026-08-10",
    latestChapter: "第700话 漩涡鸣人",
    hot: true,
    chapters: [
      { id: "ch-01", title: "第1话 漩涡鸣人", date: "2026-08-10", pageCount: 8 },
      { id: "ch-02", title: "第2话 木叶丸", date: "2026-08-03", pageCount: 8 },
      { id: "ch-03", title: "第3话 宇智波佐助", date: "2026-07-27", pageCount: 8 },
      { id: "ch-04", title: "第4话 卡卡西老师", date: "2026-07-20", pageCount: 8 },
      { id: "ch-05", title: "第5话 波之国任务", date: "2026-07-13", pageCount: 8 },
      { id: "ch-06", title: "第6话 写轮眼的少年", date: "2026-07-06", pageCount: 8 },
    ],
  },
  {
    id: "yinhun",
    title: "银魂",
    altTitle: "GINTAMA / 万事屋的爆笑日常",
    author: "空知英秋",
    cover:
      "https://readdy.ai/api/search-image?query=anime%20manga%20cover%20art%20of%20a%20silver%20haired%20samurai%20with%20lazy%20eyes%20holding%20a%20wooden%20sword%2C%20wearing%20black%20clothes%2C%20slightly%20smirking%2C%20japanese%20street%20background%20with%20warm%20evening%20light%2C%20clean%20simple%20background%2C%20high%20quality%20anime%20illustration%2C%20no%20text&width=480&height=640&seq=cover-gintama&orientation=portrait",
    status: "已完结",
    rating: 9.5,
    views: "2.1亿",
    fans: "96万",
    categories: ["gaoxiao", "rexue"],
    tags: ["搞笑", "武士", "恶搞", "日常"],
    description:
      "《银魂》是空知英秋创作的无厘头搞笑热血漫画。幕末时代被天人入侵的江户，万事屋老板坂田银时与伙伴们接下各种离谱委托，在爆笑与热泪交织的日常中，守护属于他们的武士道精神。",
    updatedAt: "2026-08-09",
    latestChapter: "第704话 银时与万事屋",
    chapters: [
      { id: "ch-01", title: "第1话 银色之魂", date: "2026-08-09", pageCount: 8 },
      { id: "ch-02", title: "第2话 万事屋开业", date: "2026-08-02", pageCount: 8 },
      { id: "ch-03", title: "第3话 天然卷的逆袭", date: "2026-07-26", pageCount: 8 },
      { id: "ch-04", title: "第4话 糖分即是正义", date: "2026-07-19", pageCount: 8 },
      { id: "ch-05", title: "第5话 战斗开始", date: "2026-07-12", pageCount: 8 },
      { id: "ch-06", title: "第6话 武士之魂", date: "2026-07-05", pageCount: 8 },
    ],
  },
  {
    id: "paiqiu-shaonian",
    title: "排球少年",
    altTitle: "排球少年!! / 乌野高中的制霸之路",
    author: "古馆春一",
    cover:
      "https://readdy.ai/api/search-image?query=anime%20manga%20cover%20art%20of%20a%20short%20orange%20haired%20boy%20wearing%20a%20black%20and%20orange%20volleyball%20uniform%20holding%20a%20volleyball%2C%20energetic%20expression%2C%20bright%20gymnasium%20background%2C%20clean%20simple%20background%2C%20vibrant%20colors%2C%20high%20quality%20anime%20illustration%2C%20no%20text&width=480&height=640&seq=cover-haikyuu&orientation=portrait",
    status: "已完结",
    rating: 9.7,
    views: "1.8亿",
    fans: "88万",
    categories: ["yundong", "xiaoyuan"],
    tags: ["排球", "青春", "团队", "励志"],
    description:
      "《排球少年》是古馆春一创作的青春运动漫画巅峰之作。身材矮小的日向翔阳在中学时代见识到「小巨人」的风采后立志打排球，加入乌野高中排球部，与天才二传手影山飞雄等伙伴一起，向着全国大赛的顶点发起冲击。",
    updatedAt: "2026-08-08",
    latestChapter: "第402话 终点与起点",
    chapters: [
      { id: "ch-01", title: "第1话 小巨人", date: "2026-08-08", pageCount: 8 },
      { id: "ch-02", title: "第2话 乌野高中", date: "2026-08-01", pageCount: 8 },
      { id: "ch-03", title: "第3话 影山飞雄", date: "2026-07-25", pageCount: 8 },
      { id: "ch-04", title: "第4话 第一场练习赛", date: "2026-07-18", pageCount: 8 },
      { id: "ch-05", title: "第5话 垃圾场决战", date: "2026-07-11", pageCount: 8 },
      { id: "ch-06", title: "第6话 全国大赛开幕", date: "2026-07-04", pageCount: 8 },
    ],
  },
  {
    id: "shizhi-zhiling",
    title: "食戟之灵",
    altTitle: "食戟之灵 / 料理界的食之对决",
    author: "附田祐斗",
    cover:
      "https://readdy.ai/api/search-image?query=anime%20manga%20cover%20art%20of%20a%20young%20chef%20boy%20wearing%20a%20white%20chef%20jacket%20with%20a%20red%20headband%20holding%20a%20plated%20gourmet%20dish%2C%20steaming%20food%20background%2C%20clean%20simple%20background%2C%20warm%20appetizing%20colors%2C%20high%20quality%20anime%20illustration%2C%20no%20text&width=480&height=640&seq=cover-foodwars&orientation=portrait",
    status: "已完结",
    rating: 9.3,
    views: "1.2亿",
    fans: "65万",
    categories: ["gaoxiao", "xiaoyuan"],
    tags: ["美食", "料理", "校园", "对决"],
    description:
      "《食戟之灵》是附田祐斗原作、佐伯俊作画的美食热血漫画。家里经营小饭馆的幸平创真进入名门料理学校「远月学园」，在名为「食戟」的料理对决中不断挑战强敌，用充满创意的料理征服每一位评委的味蕾。",
    updatedAt: "2026-08-07",
    latestChapter: "第325话 新的料理之路",
    chapters: [
      { id: "ch-01", title: "第1话 平民料理", date: "2026-08-07", pageCount: 8 },
      { id: "ch-02", title: "第2话 远月学园", date: "2026-07-31", pageCount: 8 },
      { id: "ch-03", title: "第3话 食戟开战", date: "2026-07-24", pageCount: 8 },
      { id: "ch-04", title: "第4话 香料与料理", date: "2026-07-17", pageCount: 8 },
      { id: "ch-05", title: "第5话 秋季选拔", date: "2026-07-10", pageCount: 8 },
      { id: "ch-06", title: "第6话 顶点的对决", date: "2026-07-03", pageCount: 8 },
    ],
  },
  {
    id: "zhoushu-huizhan",
    title: "咒术回战",
    altTitle: "咒术回战 / 诅咒与咒术师之战",
    author: "芥见下下",
    cover:
      "https://readdy.ai/api/search-image?query=anime%20manga%20cover%20art%20of%20a%20white%20haired%20boy%20with%20blue%20eyes%20and%20faint%20marks%20under%20his%20eyes%20wearing%20a%20dark%20school%20uniform%2C%20serious%20expression%2C%20dark%20mysterious%20background%20with%20subtle%20warm%20glow%2C%20clean%20simple%20background%2C%20high%20quality%20anime%20illustration%2C%20no%20text&width=480&height=640&seq=cover-jjk&orientation=portrait",
    status: "连载中",
    rating: 9.4,
    views: "2.6亿",
    fans: "168万",
    categories: ["rexue", "qihuan", "zhentan"],
    tags: ["咒术", "战斗", "黑暗", "奇幻"],
    description:
      "《咒术回战》是芥见下下创作的黑暗热血漫画。高中生虎杖悠仁为拯救被咒物附身的同学，吞下了特级咒物「两面宿傩的手指」，从此成为咒术师与诅咒共存之人。他加入东京都立咒术高等专门学校，在涩谷事变等残酷战斗中与伙伴并肩作战。",
    updatedAt: "2026-08-06",
    latestChapter: "第268话 决意",
    hot: true,
    chapters: [
      { id: "ch-01", title: "第1话 两面宿傩", date: "2026-08-06", pageCount: 8 },
      { id: "ch-02", title: "第2话 为了同伴", date: "2026-07-30", pageCount: 8 },
      { id: "ch-03", title: "第3话 咒术高专", date: "2026-07-23", pageCount: 8 },
      { id: "ch-04", title: "第4话 少年院", date: "2026-07-16", pageCount: 8 },
      { id: "ch-05", title: "第5话 涩谷事变", date: "2026-07-09", pageCount: 8 },
      { id: "ch-06", title: "第6话 诅咒之王", date: "2026-07-02", pageCount: 8 },
    ],
  },
  {
    id: "jindie-guojia",
    title: "间谍过家家",
    altTitle: "SPY×FAMILY / 伪装家庭的大冒险",
    author: "远藤达哉",
    cover:
      "https://readdy.ai/api/search-image?query=anime%20manga%20cover%20art%20of%20a%20man%20in%20a%20suit%20with%20spiky%20blonde%20hair%20wearing%20dark%20glasses%20holding%20hands%20with%20a%20girl%20with%20pink%20hair%20with%20little%20horns%2C%20warm%20family%20background%2C%20clean%20simple%20background%2C%20bright%20cheerful%20colors%2C%20high%20quality%20anime%20illustration%2C%20no%20text&width=480&height=640&seq=cover-spyfamily&orientation=portrait",
    status: "连载中",
    rating: 9.4,
    views: "2.2亿",
    fans: "142万",
    categories: ["gaoxiao", "xiaoyuan"],
    tags: ["间谍", "家庭", "搞笑", "日常"],
    description:
      "《间谍过家家》是远藤达哉创作的爆款喜剧漫画。西国精英间谍「黄昏」为了执行任务，临时组建了一个伪装家庭：会读心的超能力女儿阿尼亚和职业杀手妻子约尔。这个互相隐瞒真实身份的三口之家，展开了一段啼笑皆非又温暖人心的家庭故事。",
    updatedAt: "2026-08-05",
    latestChapter: "第103话 家庭任务",
    chapters: [
      { id: "ch-01", title: "第1话 行动代号", date: "2026-08-05", pageCount: 8 },
      { id: "ch-02", title: "第2话 阿尼亚来了", date: "2026-07-29", pageCount: 8 },
      { id: "ch-03", title: "第3话 母亲大人", date: "2026-07-22", pageCount: 8 },
      { id: "ch-04", title: "第4话 学院入学", date: "2026-07-15", pageCount: 8 },
      { id: "ch-05", title: "第5话 家庭出游", date: "2026-07-08", pageCount: 8 },
      { id: "ch-06", title: "第6话 秘密暴露?", date: "2026-07-01", pageCount: 8 },
    ],
  },
  {
    id: "jinji-de-juren",
    title: "进击的巨人",
    altTitle: "进击的巨人 / 自由与命运的悲歌",
    author: "谏山创",
    cover:
      "https://readdy.ai/api/search-image?query=anime%20manga%20cover%20art%20of%20a%20young%20soldier%20with%20short%20black%20hair%20wearing%20brown%20military%20jacket%20with%20white%20cloak%2C%20determined%20serious%20expression%2C%20ruined%20city%20wall%20background%20with%20dramatic%20warm%20light%2C%20clean%20simple%20background%2C%20high%20quality%20anime%20illustration%2C%20no%20text&width=480&height=640&seq=cover-aot&orientation=portrait",
    status: "已完结",
    rating: 9.6,
    views: "3.5亿",
    fans: "235万",
    categories: ["rexue", "dongzuo", "zhentan"],
    tags: ["巨人", "战争", "生存", "黑暗"],
    description:
      "《进击的巨人》是谏山创创作的黑暗史诗级漫画。在巨大的城墙守护下，人类苟活于巨人的威胁之中。少年艾伦亲眼目睹母亲被巨人吞噬后，发誓驱逐所有巨人。随着墙外的真相逐渐揭开，一个关于自由与宿命、仇恨与救赎的宏大故事缓缓展开。",
    updatedAt: "2026-08-04",
    latestChapter: "第139话 自由",
    chapters: [
      { id: "ch-01", title: "第1话 至二千年后的你", date: "2026-08-04", pageCount: 8 },
      { id: "ch-02", title: "第2话 那一天", date: "2026-07-28", pageCount: 8 },
      { id: "ch-03", title: "第3话 训练兵团", date: "2026-07-21", pageCount: 8 },
      { id: "ch-04", title: "第4话 女巨人", date: "2026-07-14", pageCount: 8 },
      { id: "ch-05", title: "第5话 兽之巨人", date: "2026-07-07", pageCount: 8 },
      { id: "ch-06", title: "第6话 墙的另一侧", date: "2026-06-30", pageCount: 8 },
    ],
  },
  {
    id: "longzhu",
    title: "龙珠",
    altTitle: "七龙珠 / 武道与力量的传说",
    author: "鸟山明",
    cover:
      "https://readdy.ai/api/search-image?query=anime%20manga%20cover%20art%20of%20a%20young%20martial%20artist%20boy%20with%20wild%20black%20spiky%20hair%20wearing%20an%20orange%20gi%20with%20blue%20belt%20in%20a%20fighting%20stance%20with%20glowing%20energy%2C%20dynamic%20shonen%20pose%2C%20clean%20simple%20background%2C%20vibrant%20colors%2C%20high%20quality%20anime%20illustration%2C%20no%20text&width=480&height=640&seq=cover-dragonball&orientation=portrait",
    status: "已完结",
    rating: 9.7,
    views: "4.1亿",
    fans: "298万",
    categories: ["rexue", "dongzuo"],
    tags: ["武道", "战斗", "冒险", "经典"],
    description:
      "《龙珠》是鸟山明创作的开创性热血格斗漫画。少年悟空与布尔玛一起踏上寻找七颗龙珠的冒险，结识龟仙人、克林等伙伴，在不断修炼与战斗中突破极限，从地球打到宇宙，从武道会打到神之领域，铸就了一段跨越时代的传说。",
    updatedAt: "2026-08-03",
    latestChapter: "第520话 和平的结束",
    chapters: [
      { id: "ch-01", title: "第1话 悟空与布尔玛", date: "2026-08-03", pageCount: 8 },
      { id: "ch-02", title: "第2话 龟仙人的修行", date: "2026-07-27", pageCount: 8 },
      { id: "ch-03", title: "第3话 天下第一武道会", date: "2026-07-20", pageCount: 8 },
      { id: "ch-04", title: "第4话 比克的威胁", date: "2026-07-13", pageCount: 8 },
      { id: "ch-05", title: "第5话 超级赛亚人", date: "2026-07-06", pageCount: 8 },
      { id: "ch-06", title: "第6话 赛亚人篇开幕", date: "2026-06-29", pageCount: 8 },
    ],
  },
  {
    id: "mingzhen-tankon",
    title: "名侦探柯南",
    altTitle: "名侦探柯南 / 真相只有一个",
    author: "青山刚昌",
    cover:
      "https://readdy.ai/api/search-image?query=anime%20manga%20cover%20art%20of%20a%20small%20boy%20detective%20wearing%20blue%20jacket%20with%20red%20bow%20tie%20and%20large%20glasses%2C%20confident%20smirk%2C%20warm%20city%20background%20at%20dusk%2C%20clean%20simple%20background%2C%20high%20quality%20anime%20illustration%2C%20no%20text&width=480&height=640&seq=cover-conan&orientation=portrait",
    status: "连载中",
    rating: 9.3,
    views: "3.9亿",
    fans: "268万",
    categories: ["zhentan", "xiaoyuan"],
    tags: ["推理", "悬疑", "侦探", "犯罪"],
    description:
      "《名侦探柯南》是青山刚昌创作的超长连载推理漫画。高中生侦探工藤新一被黑衣组织灌下毒药后身体缩小，化名江户川柯南寄住在毛利小五郎家中，一边暗中调查组织，一边用高超的推理能力破解一个个离奇案件，「真相只有一个」。",
    updatedAt: "2026-08-02",
    latestChapter: "第1130话 红与黑的碰撞",
    chapters: [
      { id: "ch-01", title: "第1话 变成小学生的侦探", date: "2026-08-02", pageCount: 8 },
      { id: "ch-02", title: "第2话 密室杀人事件", date: "2026-07-26", pageCount: 8 },
      { id: "ch-03", title: "第3话 黑暗组织", date: "2026-07-19", pageCount: 8 },
      { id: "ch-04", title: "第4话 密室之谜", date: "2026-07-12", pageCount: 8 },
      { id: "ch-05", title: "第5话 怪盗基德", date: "2026-07-05", pageCount: 8 },
      { id: "ch-06", title: "第6话 红黑对决", date: "2026-06-28", pageCount: 8 },
    ],
  },
  {
    id: "siwang-biji",
    title: "死亡笔记",
    altTitle: "死亡笔记 / 死神的笔记本",
    author: "大场鸫",
    cover:
      "https://readdy.ai/api/search-image?query=anime%20manga%20cover%20art%20of%20a%20slim%20dark%20haired%20teenager%20holding%20a%20black%20notebook%20with%20a%20slight%20smirk%2C%20red%20apple%20beside%20him%2C%20dark%20moody%20background%20with%20warm%20amber%20glow%2C%20clean%20simple%20background%2C%20high%20quality%20anime%20illustration%2C%20no%20text&width=480&height=640&seq=cover-deathnote&orientation=portrait",
    status: "已完结",
    rating: 9.5,
    views: "1.6亿",
    fans: "78万",
    categories: ["zhentan", "qihuan"],
    tags: ["推理", "智斗", "黑暗", "死神"],
    description:
      "《死亡笔记》是大场鸫原作、小畑健作画的智斗神作。天才高中生夜神月捡到了死神琉克掉落的死亡笔记，凡是名字被写入笔记的人都会死亡。自诩为「新世界的神」的月与天才侦探L展开了一场惊心动魄的智谋对决。",
    updatedAt: "2026-08-01",
    latestChapter: "第108话 终焉",
    chapters: [
      { id: "ch-01", title: "第1话 无聊", date: "2026-08-01", pageCount: 8 },
      { id: "ch-02", title: "第2话 L现身", date: "2026-07-25", pageCount: 8 },
      { id: "ch-03", title: "第3话 对决开始", date: "2026-07-18", pageCount: 8 },
      { id: "ch-04", title: "第4话 基拉vsL", date: "2026-07-11", pageCount: 8 },
      { id: "ch-05", title: "第5话 死神之眼", date: "2026-07-04", pageCount: 8 },
      { id: "ch-06", title: "第6话 最后的博弈", date: "2026-06-27", pageCount: 8 },
    ],
  },
  {
    id: "wode-yingxiong-xueyuan",
    title: "我的英雄学院",
    altTitle: "我的英雄学院 / Plus Ultra!",
    author: "堀越耕平",
    cover:
      "https://readdy.ai/api/search-image?query=anime%20manga%20cover%20art%20of%20a%20green%20haired%20boy%20with%20freckles%20wearing%20a%20red%20and%20blue%20hero%20costume%20with%20white%20hood%20and%20wide%20black%20eyes%2C%20determined%20expression%2C%20bright%20hero%20academy%20background%2C%20clean%20simple%20background%2C%20vibrant%20colors%2C%20high%20quality%20anime%20illustration%2C%20no%20text&width=480&height=640&seq=cover-mha&orientation=portrait",
    status: "连载中",
    rating: 9.2,
    views: "1.9亿",
    fans: "108万",
    categories: ["rexue", "xiaoyuan"],
    tags: ["英雄", "校园", "超能力", "成长"],
    description:
      "《我的英雄学院》是堀越耕平创作的王道热血漫画。在一个八成人口都拥有「个性」的超能力社会，天生无个性的少年绿谷出久却怀揣着成为最强英雄的梦想。他继承了最强英雄欧尔麦特的个性，进入雄英高中，在成为「最棒的英雄」的道路上全力奔跑。",
    updatedAt: "2026-07-31",
    latestChapter: "第430话 余烬",
    chapters: [
      { id: "ch-01", title: "第1话 绿谷出久", date: "2026-07-31", pageCount: 8 },
      { id: "ch-02", title: "第2话 欧尔麦特", date: "2026-07-24", pageCount: 8 },
      { id: "ch-03", title: "第3话 入学考试", date: "2026-07-17", pageCount: 8 },
      { id: "ch-04", title: "第4话 英雄杀手", date: "2026-07-10", pageCount: 8 },
      { id: "ch-05", title: "第5话 体育祭", date: "2026-07-03", pageCount: 8 },
      { id: "ch-06", title: "第6话 新的一步", date: "2026-06-26", pageCount: 8 },
    ],
  },
  {
    id: "wangqiu-wangzi",
    title: "网球王子",
    altTitle: "网球王子 / 越前龙马的网球之路",
    author: "许斐刚",
    cover:
      "https://readdy.ai/api/search-image?query=anime%20manga%20cover%20art%20of%20a%20boy%20with%20teal%20green%20hair%20wearing%20a%20white%20and%20green%20tennis%20uniform%20holding%20a%20tennis%20racquet%20over%20his%20shoulder%2C%20confident%20slight%20smile%2C%20bright%20tennis%20court%20background%2C%20clean%20simple%20background%2C%20high%20quality%20anime%20illustration%2C%20no%20text&width=480&height=640&seq=cover-tennis&orientation=portrait",
    status: "已完结",
    rating: 9.0,
    views: "1.4亿",
    fans: "72万",
    categories: ["yundong", "xiaoyuan"],
    tags: ["网球", "校园", "竞技", "天才"],
    description:
      "《网球王子》是许斐刚创作的经典网球漫画。天才少年越前龙马从美国回到日本，进入网球名校青春学园，与网球部的前辈们一起征战全国大赛，凭借「无我境界」「单脚小碎步」等绝技战胜一个又一个强大对手。",
    updatedAt: "2026-07-30",
    latestChapter: "第379话 超越自我",
    chapters: [
      { id: "ch-01", title: "第1话 越前龙马", date: "2026-07-30", pageCount: 8 },
      { id: "ch-02", title: "第2话 青春学园", date: "2026-07-23", pageCount: 8 },
      { id: "ch-03", title: "第3话 校内排名赛", date: "2026-07-16", pageCount: 8 },
      { id: "ch-04", title: "第4话 全国大赛", date: "2026-07-09", pageCount: 8 },
      { id: "ch-05", title: "第5话 无我境界", date: "2026-07-02", pageCount: 8 },
      { id: "ch-06", title: "第6话 决赛的约定", date: "2026-06-25", pageCount: 8 },
    ],
  },
  {
    id: "xiamu-yourenzhang",
    title: "夏目友人帐",
    altTitle: "夏目友人帐 / 妖怪与温柔的羁绊",
    author: "绿川幸",
    cover:
      "https://readdy.ai/api/search-image?query=anime%20manga%20cover%20art%20of%20a%20gentle%20brown%20haired%20boy%20wearing%20a%20white%20shirt%20with%20a%20round%20white%20cat%20beside%20him%2C%20soft%20warm%20expression%2C%20tranquil%20green%20nature%20background%20with%20soft%20sunlight%2C%20clean%20simple%20background%2C%20gentle%20warm%20colors%2C%20high%20quality%20anime%20illustration%2C%20no%20text&width=480&height=640&seq=cover-natsume&orientation=portrait",
    status: "连载中",
    rating: 9.5,
    views: "9800万",
    fans: "56万",
    categories: ["qihuan", "xiaoyuan"],
    tags: ["妖怪", "治愈", "温情", "日常"],
    description:
      "《夏目友人帐》是绿川幸创作的治愈系妖怪漫画。能看见妖怪的少年夏目贵志继承了祖母玲子的「友人帐」，为了让妖怪们夺回自己的名字，他与招财猫外形的斑一起踏上了归还名字的旅程，也在这段旅程中收获了与妖怪们的温暖羁绊。",
    updatedAt: "2026-07-29",
    latestChapter: "第147话 温柔的约定",
    chapters: [
      { id: "ch-01", title: "第1话 玲子的友人帐", date: "2026-07-29", pageCount: 8 },
      { id: "ch-02", title: "第2话 招财猫斑", date: "2026-07-22", pageCount: 8 },
      { id: "ch-03", title: "第3话 第一只妖怪", date: "2026-07-15", pageCount: 8 },
      { id: "ch-04", title: "第4话 名字的归还", date: "2026-07-08", pageCount: 8 },
      { id: "ch-05", title: "第5话 夏日祭典", date: "2026-07-01", pageCount: 8 },
      { id: "ch-06", title: "第6话 温柔的羁绊", date: "2026-06-24", pageCount: 8 },
    ],
  },
  {
    id: "qimu-nanxiong",
    title: "齐木楠雄的灾难",
    altTitle: "齐木楠雄的灾难 / 超能力者的日常",
    author: "麻生周一",
    cover:
      "https://readdy.ai/api/search-image?query=anime%20manga%20cover%20art%20of%20a%20boy%20with%20pink%20hair%20and%20two%20small%20antennae%20on%20his%20head%20wearing%20a%20school%20uniform%20with%20a%20blank%20expression%2C%20bright%20simple%20school%20background%2C%20clean%20simple%20background%2C%20playful%20vibrant%20colors%2C%20high%20quality%20anime%20illustration%2C%20no%20text&width=480&height=640&seq=cover-saiki&orientation=portrait",
    status: "已完结",
    rating: 9.2,
    views: "8600万",
    fans: "48万",
    categories: ["gaoxiao", "xiaoyuan", "qihuan"],
    tags: ["超能力", "搞笑", "校园", "日常"],
    description:
      "《齐木楠雄的灾难》是麻生周一创作的搞笑漫画。拥有心灵感应、念动力等几乎所有超能力的高中生齐木楠雄，只想平静地度过校园生活，却总被一群性格奇葩的同学缠上。不想引人注目的超能力者，每一天都在上演哭笑不得的灾难日常。",
    updatedAt: "2026-07-28",
    latestChapter: "第300话 灾难的结束",
    chapters: [
      { id: "ch-01", title: "第1话 超能力者", date: "2026-07-28", pageCount: 8 },
      { id: "ch-02", title: "第2话 麻烦的同学", date: "2026-07-21", pageCount: 8 },
      { id: "ch-03", title: "第3话 海藤瞬", date: "2026-07-14", pageCount: 8 },
      { id: "ch-04", title: "第4话 照桥心美", date: "2026-07-07", pageCount: 8 },
      { id: "ch-05", title: "第5话 灾难日常", date: "2026-06-30", pageCount: 8 },
      { id: "ch-06", title: "第6话 平静的一天", date: "2026-06-23", pageCount: 8 },
    ],
  },
];

export const featuredComic = comics.find((c) => c.id === "jiating-jiaoshi")!;

export const hotComics = comics.filter((c) => c.hot);

export const latestChapters = comics
  .flatMap((c) =>
    c.chapters.slice(0, 1).map((ch) => ({
      comic: c,
      chapter: ch,
    }))
  )
  .sort((a, b) => (a.chapter.date < b.chapter.date ? 1 : -1));